import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import {
  getPreviewMemberHome,
} from "../utils/dashboardViewPref";
import AdminDashboard from "./Organization/AdminDashboard";
import UserDashboard from "./User/Dashboard";

const Dashboard: React.FC = () => {
  const { isAdmin } = useAuth();
  const [previewMemberHome, setPreviewMemberHome] = useState(getPreviewMemberHome);

  useEffect(() => {
    const onPref = (e: Event) => {
      const detail = (e as CustomEvent<{ enabled: boolean }>).detail;
      setPreviewMemberHome(Boolean(detail?.enabled));
    };
    const onStorage = (e: StorageEvent) => {
      if (e.key === "praisify.dashboardPreviewMember") {
        setPreviewMemberHome(e.newValue === "1");
      }
    };
    window.addEventListener("praisify:dashboard-view-pref", onPref);
    window.addEventListener("storage", onStorage);
    return () => {
      window.removeEventListener("praisify:dashboard-view-pref", onPref);
      window.removeEventListener("storage", onStorage);
    };
  }, []);

  if (!isAdmin || previewMemberHome) {
    return <UserDashboard />;
  }

  return <AdminDashboard />;
};

export default Dashboard;
